<template>
  <button class="trbo-a-question-back-button" @click="onClick">
    <icon name="back" class="trbo-a-question-back-button__icon" />
    <div class="trbo-a-question-back-button__title">
      {{ $t('wizard.back') }}
    </div>
  </button>
</template>

<script>
// @flow

import Icon from '../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped src="./question-back-button.scss" />
